module.exports = __webpack_public_path__ + "assets/924707ced3739840cfe849049df7d5d6.png";